/**
 * callec-wishlist — 自作お気に入りのフロント側。
 *
 * 役割:
 *   - 状態(どの variant がどこかのリストに入っているか)を1箇所で持つ
 *   - ページ内の全ハート(PDP・カード・ヘッダーのバッジ)を同じ状態で描く
 *   - 追加/削除は楽観的更新。失敗したら戻してトーストで伝える
 *
 * 前提: window.CEC_WISHLIST_CONFIG が layout で定義されていること。
 *   { proxy: '/apps/wishlist', loggedIn: true|false, loginUrl: '/account/login' }
 *
 * 注意: 商品カードは Section Rendering で後から差し替わる。DOM に足された
 * ハートへ状態を当て直すため MutationObserver を使う。
 */
(function () {
  'use strict';

  var CFG = window.CEC_WISHLIST_CONFIG || {};
  var PROXY = CFG.proxy || '/apps/wishlist';
  var LOGGED_IN = !!CFG.loggedIn;
  var LOGIN_URL = CFG.loginUrl || '/account/login';

  var state = {
    ready: false,
    variants: new Set(),   // どこかのリストに入っている variant_id(ハート全体の判定用)
    byList: {},            // list_id -> Set(variant_id)。「試着したい」など特定リスト用
    lists: [],             // [{id,name,kind,count}]
  };

  /** kind からリストIDを引く(試着したい = store) */
  function listIdByKind(kind) {
    for (var i = 0; i < state.lists.length; i++) {
      if (state.lists[i].kind === kind) return state.lists[i].id;
    }
    return null;
  }

  function setOf(listId) {
    var key = String(listId);
    if (!state.byList[key]) state.byList[key] = new Set();
    return state.byList[key];
  }

  /** どのリストにも残っていなければ、全体の判定からも外す */
  function refreshFlat(vid) {
    var found = false;
    Object.keys(state.byList).forEach(function (k) {
      if (state.byList[k].has(vid)) found = true;
    });
    if (found) state.variants.add(vid); else state.variants.delete(vid);
  }

  var listeners = [];
  function emit() {
    applyAll();
    listeners.forEach(function (fn) {
      try { fn(state); } catch (e) { /* 購読側の失敗で全体を止めない */ }
    });
  }

  // ---- API ----------------------------------------------------------------

  function api(path, options) {
    return fetch(PROXY + path, Object.assign({
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
    }, options || {})).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (body) {
        if (!res.ok) {
          var err = new Error(body.error || '通信に失敗しました');
          err.code = body.code;
          err.status = res.status;
          throw err;
        }
        return body;
      });
    });
  }

  function post(path, payload) {
    return api(path, { method: 'POST', body: JSON.stringify(payload || {}) });
  }

  // ---- 状態の描画 ----------------------------------------------------------

  function applyToButton(btn) {
    var vid = String(btn.getAttribute('data-wl-variant') || '');
    var kind = btn.getAttribute('data-wl-list-kind');
    // そのボタンが対象にしているリストに入っているかで判定する。
    // 「どこかのリストに入っているか」で塗ると、試着したいに入れただけの商品で
    // お気に入りボタンまで「済み」になり、押しても外れないように見える。
    var lid = listIdByKind(kind || 'default');
    var on = lid !== null
      ? !!vid && setOf(lid).has(vid)
      : !!vid && state.variants.has(vid);
    var off = btn.getAttribute('data-wl-label') || 'お気に入り';
    var onLabel = btn.getAttribute('data-wl-label-on') || 'お気に入り済み';
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-label', on ? off + 'から削除' : off + 'に追加');
    var text = btn.querySelector('[data-wl-text]');
    if (text) text.textContent = on ? onLabel : off;
  }

  function applyAll() {
    document.querySelectorAll('[data-wl-btn]').forEach(applyToButton);
    var count = state.lists.reduce(function (sum, l) {
      // あとで買うはカートの延長なのでバッジに数えない
      return l.kind === 'sfl' ? sum : sum + (l.count || 0);
    }, 0);
    document.querySelectorAll('[data-wl-badge]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.hidden = count === 0;
    });
  }

  // ---- トースト ------------------------------------------------------------

  var toastTimer = null;
  function toast(message, action) {
    var el = document.getElementById('cec-wl-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'cec-wl-toast';
      el.className = 'cec-wl-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    el.appendChild(span);
    if (action) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cec-wl-toast__action';
      btn.textContent = action.label;
      btn.addEventListener('click', function () {
        hideToast();
        action.onClick();
      });
      el.appendChild(btn);
    }
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, action ? 6000 : 3000);
  }
  function hideToast() {
    var el = document.getElementById('cec-wl-toast');
    if (el) el.classList.remove('is-visible');
  }

  // ---- 操作 ----------------------------------------------------------------

  var PENDING_KEY = 'cec_wl_pending';

  /**
   * ログインへ送る。戻ってきた時に同じ場所へ返す。
   * 新顧客アカウントは /customer_authentication/login?return_to=<相対URL> を見る。
   */
  function requireLogin(pending) {
    showLoginSheet(function () { goLogin(pending); });
  }

  /**
   * いきなりログイン画面へ移らず、理由と選択肢を下から出す。
   * 文言は layout の CEC_WISHLIST_CONFIG.loginSheet で変えられる。
   */
  function showLoginSheet(onLogin) {
    var text = CFG.loginSheet || {};
    var dlg = document.getElementById('cec-wl-login-sheet');
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.id = 'cec-wl-login-sheet';
      dlg.className = 'cec-wl-login-sheet';
      dlg.setAttribute('aria-labelledby', 'cec-wl-login-sheet-title');
      dlg.innerHTML =
        '<p class="cec-wl-login-sheet__title" id="cec-wl-login-sheet-title"></p>' +
        '<p class="cec-wl-login-sheet__body"></p>' +
        '<div class="cec-wl-login-sheet__actions">' +
        '<button type="button" class="cec-wl-login-sheet__login" data-wl-sheet-login></button>' +
        '<button type="button" class="cec-wl-login-sheet__later" data-wl-sheet-later></button>' +
        '</div>';
      dlg.querySelector('.cec-wl-login-sheet__title').textContent = text.title || 'お気に入りは会員登録で保存できます';
      dlg.querySelector('.cec-wl-login-sheet__body').textContent = text.body || 'ログインすると、選んだ商品はそのままお気に入りに入ります。登録は無料です。';
      dlg.querySelector('[data-wl-sheet-login]').textContent = text.login || 'ログイン・会員登録へ';
      dlg.querySelector('[data-wl-sheet-later]').textContent = text.later || 'あとで';
      dlg.querySelector('[data-wl-sheet-later]').addEventListener('click', function () { dlg.close(); });
      // 外側(背景)を押したら閉じる
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      document.body.appendChild(dlg);
    }
    var loginBtn = dlg.querySelector('[data-wl-sheet-login]');
    loginBtn.onclick = function () { dlg.close(); onLogin(); };
    if (typeof dlg.showModal === 'function') {
      if (!dlg.open) dlg.showModal();
      loginBtn.focus();
    } else {
      onLogin(); // dialog 非対応の古いブラウザは従来どおり直接移る
    }
  }

  function goLogin(pending) {
    if (pending) {
      // 戻ってきたら押し直さずに済むよう、押した商品を覚えておく
      pending.at = Date.now();
      try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(pending)); } catch (e) {}
    }
    var next = window.location.pathname + window.location.search;
    var url = LOGIN_URL || CFG.loginFallbackUrl || '/account/login';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    window.location.href = url + sep + 'return_to=' + encodeURIComponent(next);
  }

  /** ログインして戻ってきた時、押しかけていたお気に入りを引き継ぐ */
  function resumePending() {
    var raw;
    try { raw = sessionStorage.getItem(PENDING_KEY); } catch (e) { return; }
    if (!raw) return;
    try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
    var p;
    try { p = JSON.parse(raw); } catch (e) { return; }
    if (!p || !p.variant_id || !p.product_id) return;
    // 同じタブに長く残った古い意図まで拾わない(ログインを途中でやめた場合など)
    if (!p.at || Date.now() - p.at > 30 * 60 * 1000) return;
    if (state.variants.has(String(p.variant_id))) return; // 既に入っている
    var lid = p.list_kind ? listIdByKind(p.list_kind) : listIdByKind('default');
    post('/add', {
      variant_id: p.variant_id,
      product_id: p.product_id,
      price: p.price,
      source: p.source,
      list_id: lid === null ? undefined : lid,
    }).then(function (body) {
      if (body.lists) state.lists = body.lists;
      if (lid !== null) setOf(lid).add(String(p.variant_id));
      state.variants.add(String(p.variant_id));
      emit();
      toast('追加しました', {
        label: 'リストを見る',
        onClick: function () { window.location.href = '/pages/wishlist'; },
      });
    }).catch(function () { /* 引き継ぎに失敗しても黙って諦める */ });
  }

  function toggle(btn) {
    var vid = String(btn.getAttribute('data-wl-variant') || '');
    var pid = String(btn.getAttribute('data-wl-product') || '');
    var price = btn.getAttribute('data-wl-price');
    var source = btn.getAttribute('data-wl-source') || 'pdp';
    if (!vid || !pid) return Promise.resolve();

    if (!LOGGED_IN) {
      requireLogin({
        variant_id: vid, product_id: pid, price: price, source: source,
        list_kind: btn.getAttribute('data-wl-list-kind') || '',
      });
      return Promise.resolve();
    }
    var kind = btn.getAttribute('data-wl-list-kind');
    var listId = kind ? listIdByKind(kind) : listIdByKind('default');
    // 試着したい等はリストIDが要る。まだ /state が返っていない時は押させない
    if (kind && listId === null) { toast('読み込み中です。少し待ってからお試しください'); return Promise.resolve(); }
    var label = btn.getAttribute('data-wl-label') || 'お気に入り';

    // お気に入りは list_id を省略すればサーバ側が既定リストへ入れる。
    // /state 到着前に押された場合でも動くよう、ID が無ければ省略する。
    var wasOn = listId === null ? state.variants.has(vid) : setOf(listId).has(vid);
    // 楽観的更新。失敗したら戻す
    if (listId !== null) {
      if (wasOn) setOf(listId).delete(vid); else setOf(listId).add(vid);
      refreshFlat(vid);
    } else {
      if (wasOn) state.variants.delete(vid); else state.variants.add(vid);
    }
    emit();

    var payload = { variant_id: vid, product_id: pid, price: price, source: source };
    var removePayload = { variant_id: vid };
    if (listId !== null) { payload.list_id = listId; removePayload.list_id = listId; }
    var call = wasOn ? post('/remove', removePayload) : post('/add', payload);

    return call.then(function (body) {
      if (body.lists) state.lists = body.lists;
      emit();
      if (!wasOn) {
        toast(label + 'に追加しました', {
          label: 'リストを見る',
          onClick: function () { window.location.href = '/pages/wishlist'; },
        });
      }
    }).catch(function (err) {
      if (listId !== null) {
        if (wasOn) setOf(listId).add(vid); else setOf(listId).delete(vid);
        refreshFlat(vid);
      } else {
        if (wasOn) state.variants.add(vid); else state.variants.delete(vid);
      }
      emit();
      if (err.code === 'login_required') { requireLogin(); return; }
      toast(err.message || '保存できませんでした');
    });
  }

  // ---- 初期化 --------------------------------------------------------------

  function load() {
    if (!LOGGED_IN) { state.ready = true; emit(); return Promise.resolve(); }
    return api('/state').then(function (body) {
      state.variants = new Set((body.variant_ids || []).map(String));
      state.byList = {};
      var raw = body.variants_by_list || {};
      Object.keys(raw).forEach(function (k) { state.byList[k] = new Set(raw[k].map(String)); });
      state.lists = body.lists || [];
      state.ready = true;
      emit();
      resumePending();
    }).catch(function (err) {
      state.ready = true;
      if (err.code === 'login_required') return; // 実質未ログイン。黙って諦める
      // API が落ちていても閲覧と購入は妨げない。ハートは無効表示にする
      document.querySelectorAll('[data-wl-btn]').forEach(function (b) { b.disabled = true; });
    });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('[data-wl-btn]') : null;
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation(); // カード全体のリンクに乗らないようにする
    toggle(btn);
  });

  /** カートが空になった時のドロワーを、手元のセクションHTMLで描き替える */
  function renderEmptyDrawer(cart) {
    var html = cart && cart.sections && cart.sections['cart-drawer'];
    var live = document.querySelector('cart-drawer');
    if (!html || !live) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector('cart-drawer') || doc.getElementById('cart-drawer');
    if (src) live.innerHTML = src.innerHTML;
  }

  /**
   * 「あとで買う」に移したことを伝える。カートから商品が消えるだけだと
   * 何が起きたか分からないため、テーマ純正の通知(add to cart と同じ見た目)を使う。
   * 使えない環境では自前のトーストに落とす。
   */
  function notifyMoved(title) {
    // 通知は innerHTML で描かれるため、商品名はここでエスケープしてから渡す
    // テーマ純正の通知は緑地に顔アイコンで、白基調の CALL のトンマナから外れる。
    // 自前のトースト(白地・細罫・黒文字)で出す。textContent で入れるのでエスケープ不要。
    toast((title ? '「' + title + '」を' : '') + '「あとで買う」に移しました', {
      label: '見る',
      onClick: function () { window.location.href = '/pages/wishlist'; },
    });
  }

  // カートの「あとで買う」: リストへ入れてからカートの明細を消す
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('[data-wl-sfl]') : null;
    if (!btn) return;
    ev.preventDefault();
    if (!LOGGED_IN) { requireLogin(); return; }
    var sfl = state.lists.filter(function (l) { return l.kind === 'sfl'; })[0];
    if (!sfl) { toast('あとで買うリストが見つかりません'); return; }
    btn.disabled = true;
    post('/add', {
      variant_id: String(btn.getAttribute('data-wl-variant')),
      product_id: String(btn.getAttribute('data-wl-product')),
      list_id: sfl.id,
      price: btn.getAttribute('data-wl-price'),
      source: 'cart',
    }).then(function (body) {
      state.lists = body.lists || state.lists;
      // テーマ(Foxkit)はカート更新時に sections の HTML で描き替える。
      // これを送らないとリロードするまでカートの見た目が変わらない。
      var sections = [];
      var push = function (id) { if (id && sections.indexOf(id) === -1) sections.push(id); };
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.getSectionsToRender) {
        drawer.getSectionsToRender(true).forEach(function (x) { push(x.id); });
      }
      var mainCart = document.querySelector('cart-items');
      if (mainCart && mainCart.getSectionsToRender) {
        mainCart.getSectionsToRender().forEach(function (x) { push(x.section || x.id); });
      }
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: btn.getAttribute('data-wl-key'),
          quantity: 0,
          sections: sections,
          sections_url: window.location.pathname,
        }),
      }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      try {
        if (window.FoxThemeEvents && window.FoxThemeEvents.emit) {
          window.FoxThemeEvents.emit('cart-update', cart);
        }
        if (window.FoxThemeCartHelpers && window.FoxThemeCartHelpers.updateCartCount) {
          window.FoxThemeCartHelpers.updateCartCount(cart.item_count);
        }
        // ドロワーは cart-update を item_count が 0 でない時しか処理しない。
        // 最後の1点を移すと描き替えが走らず商品が残って見えるため、ここで自分で差し替える。
        // テーマの cart:refresh は使わない(この構成ではドロワーが入れ子になり
        // .f-cart-drawer__items が2つできて、古い方が表示に残る)。
        if (cart.item_count === 0) renderEmptyDrawer(cart);
      } catch (e) { /* 反映の通知に失敗してもカートからは外れている */ }
      emit();
      notifyMoved(btn.getAttribute('data-wl-title'));
      btn.disabled = false;
    }).catch(function (err) {
      btn.disabled = false;
      toast(err.message || 'あとで買うに移せませんでした');
    });
  });

  /**
   * PDP でサイズや色を切り替えた時、ボタンの対象バリアントを差し替える。
   * これをしないと、最初に表示されていたサイズのまま保存してしまう。
   */
  function syncPdpVariant(variant) {
    if (!variant || !variant.id) return;
    document.querySelectorAll('[data-wl-btn][data-wl-source="pdp"]').forEach(function (btn) {
      btn.setAttribute('data-wl-variant', String(variant.id));
      if (typeof variant.price === 'number') {
        btn.setAttribute('data-wl-price', String(Math.round(variant.price / 100)));
      }
      applyToButton(btn);
    });
  }
  document.addEventListener('variant:changed', function (e) {
    syncPdpVariant(e.detail && e.detail.variant);
  });
  if (window.FoxThemeEvents && window.FoxThemeEvents.subscribe) {
    try {
      window.FoxThemeEvents.subscribe('variant-change', function (payload) {
        syncPdpVariant(payload && payload.data && payload.data.variant);
      });
    } catch (e) { /* テーマ側の実装差で購読できなくても本体は動かす */ }
  }

  // 後から差し込まれたカードにも状態を当てる
  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-wl-btn]')) applyToButton(node);
        if (node.querySelectorAll) node.querySelectorAll('[data-wl-btn]').forEach(applyToButton);
      }
    }
  });

  function start() {
    load();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.CEC_WISHLIST = {
    state: state,
    reload: load,
    toggle: toggle,
    api: api,
    post: post,
    toast: toast,
    subscribe: function (fn) { listeners.push(fn); if (state.ready) fn(state); },
  };
})();
